import {getEdit} from "../index"
import initialState from "./initialState.json"

// SELECTORS
export const getEditTables = (state) => getEdit(state).tables

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

